import { I18nService } from '../../i18n/I18nService';
import { I18N_KEYS } from '../../i18n/keys';
import { FocusTrap } from '../../accessibility/FocusTrap';
import { generateCsvContent, downloadCsv } from '../../utils/csv';

export class HistoryModal {
  private i18n: I18nService;
  private focusTrap: FocusTrap;
  private dialog: HTMLDialogElement | null = null;

  constructor(i18n: I18nService, focusTrap: FocusTrap) {
    this.i18n = i18n;
    this.focusTrap = focusTrap;
  }

  render(): void {
    this.dialog = document.getElementById('history-modal') as HTMLDialogElement;
    if (!this.dialog) {
      this.dialog = document.createElement('dialog');
      this.dialog.id = 'history-modal';
      this.dialog.className = 'modal modal--history';
      document.body.appendChild(this.dialog);
    }
  }

  open(calledNumbers: number[], startTime: string | null): void {
    if (!this.dialog) this.render();

    const rows = calledNumbers
      .map((num, i) => `<tr><td>${i + 1}</td><td>${num}</td></tr>`)
      .join('');

    this.dialog!.innerHTML = `
      <div class="modal__content">
        <div class="modal__header">
          <h2>${this.i18n.t(I18N_KEYS.HISTORY_TITLE)}</h2>
          <button class="modal__close-btn" type="button" aria-label="Close">&times;</button>
        </div>
        <div class="modal__body history__body">
          <table class="history__table">
            <thead>
              <tr>
                <th>${this.i18n.t(I18N_KEYS.HISTORY_ORDER)}</th>
                <th>${this.i18n.t(I18N_KEYS.HISTORY_NUMBER)}</th>
              </tr>
            </thead>
            <tbody>${rows}</tbody>
          </table>
        </div>
        <div class="modal__footer">
          <button id="history-export-btn" class="btn btn--secondary" type="button">${this.i18n.t(I18N_KEYS.HISTORY_EXPORT_CSV)}</button>
          <button id="history-close-btn" class="btn btn--primary" type="button">${this.i18n.t(I18N_KEYS.HISTORY_CLOSE)}</button>
        </div>
      </div>
    `;

    this.dialog!.querySelector('.modal__close-btn')?.addEventListener('click', () => this.close());
    this.dialog!.querySelector('#history-close-btn')?.addEventListener('click', () => this.close());
    this.dialog!.querySelector('#history-export-btn')?.addEventListener('click', () => {
      const csv = generateCsvContent(calledNumbers, startTime);
      downloadCsv(csv, `loto-history-${new Date().toISOString().slice(0, 10)}.csv`);
    });

    this.dialog!.showModal();
    this.focusTrap.activate(this.dialog!);
  }

  close(): void {
    this.focusTrap.deactivate();
    if (this.dialog?.open) {
      this.dialog.close();
    }
  }

  isOpen(): boolean {
    return this.dialog?.open === true;
  }
}
